import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import { Calendar } from '../assets/icons'
import { InputContainer, InputIconLeft, StyledInput } from './ui/input/styled'
import useIsMobile from '../hooks/useIsMobile'
import { Text2 } from './ui/text'
import theme from '../styled/theme'

const CalendarDropdown = styled.div`
	position: absolute;
	top: 110%;
	left: 0;
	z-index: 10;
	background: #fff;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
	border-radius: 4px;
	padding: 16px;
`

export default function DualDateInput({ value, onChange, renderCalendar, width }) {
	const isMobile = useIsMobile();
	const [showCalendar, setShowCalendar] = useState(false)
	const [focusedInput, setFocusedInput] = useState('startDate')
	const inputRef = useRef(null)
	const formatRange = (start, end) => {
		if (!start && !end) return ''
		if (start && !end) return `${start.format('DD/MM/YYYY')} -`
		if (!start && end) return `- ${end.format('DD/MM/YYYY')}`
		return `${start.format('DD/MM/YYYY')} - ${end.format('DD/MM/YYYY')}`
	}

	const handleInputClick = () => {
		setFocusedInput(value.startDate && !value.endDate ? 'endDate' : 'startDate')
		setShowCalendar(prev => !prev)
	}

	const handleCalendarChange = ({ startDate, endDate }) => {
		onChange({ startDate, endDate })
		if (focusedInput === 'endDate' && startDate && endDate) {
			setShowCalendar(false)
		}
	}

	const handleFocusChange = nextFocusedInput => {
		if (!nextFocusedInput) {
			setShowCalendar(false)
			return
		}

		setFocusedInput(nextFocusedInput)
		if (!showCalendar) {
			setShowCalendar(true)
		}
	}

	return (
		<InputContainer width={width ? width : '100%'} >
			<InputIconLeft>
				<Calendar />
			</InputIconLeft>
			<StyledInput
				width={'100%'}
				$hasLeft={true}
				ref={inputRef}
				readOnly
				value={formatRange(value.startDate, value.endDate)}
				onClick={handleInputClick}
				placeholder="Seleccioná"
			/>
			{showCalendar && (
				<CalendarDropdown>
					{renderCalendar({
						...value,
						onDatesChange: handleCalendarChange,
						focusedInput,
						onFocusChange: handleFocusChange,
						onClose: () => setShowCalendar(false)
					})}
				</CalendarDropdown>
			)}
		</InputContainer>
	)
}
